import { render, staticRenderFns } from "./LandingPageCMS.vue?vue&type=template&id=37f20875&scoped=true"
import script from "./LandingPageCMS.vue?vue&type=script&lang=js"
export * from "./LandingPageCMS.vue?vue&type=script&lang=js"
import style0 from "./LandingPageCMS.vue?vue&type=style&index=0&id=37f20875&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f20875",
  null
  
)

export default component.exports